import React, { type FC } from 'react'
import { Flex, Spin, Typography } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

const { Title } = Typography

interface IWppLoadingSpinnerProps {
  tip?: string
  fontSize?: number
  fullScreen?: boolean
}

export const WppLoadingSpinner: FC<IWppLoadingSpinnerProps> = ({
  tip = 'Loading...',
  fontSize = 64,
  fullScreen = true
}) => (
  <Flex
    align='center'
    gap='middle'
    justify='center'
    className={`loading__container wpp-loading__container ${fullScreen ? 'wpp-loading__container--full-screen' : ''}`}>
    <div>
      <Spin
        className='loading__spinner'
        indicator={
          <LoadingOutlined style={{ fontSize }} spin={true} />
        }>
      </Spin>
      <Title level={3}>{tip}</Title>
    </div>
  </Flex>
)
